/*  Shared  */
import { State, StateTenant } from 'application/Shared/types/state';

/*  React  */
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

/**
 * Custom hook to to load tenants information.
 * @param {string} tenantId
 * @returns {StateTenant | null} The tenants object.
 */
export const useTenantInfoByTenantId = (
    tenantId: string = ''
): StateTenant | null => useSelector((state: State) => state.tenants[tenantId]);

/**
 * Custom hook to determine if a tenant has a feature flag enabled.
 * @param {string} featureFlag
 * @returns {boolean} True if the tenant has the feature flag enabled, False otherwise.
 */
export const useHasFeatureFlag = (featureFlag: string): boolean => {
    const { partnerId, clientId } = useParams();
    // If we do have a partnerId in the URL, use that since, currently, all
    // tenantSettings-based feature flags are inherited from the partner tenant.
    // If we do not have a partnerId in the URL, use the clientId.
    const tenantIdToUse = (partnerId || clientId)!;

    const tenantInfo = useTenantInfoByTenantId(tenantIdToUse);
    const tenant = tenantInfo?.tenant;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - feature flag unknown
    return !!tenant?.settings?.[featureFlag];
};
